<template>
    <div>
      <div class="bg-grey rounded p-6 md:ml-8">
        <p>
          <strong>Not you?</strong><br />
          <a href="#" v-if="!verifyForm" @click="verifyForm = true">Click here to re-verify</a>
        </p>
  
        <div v-if="verifyForm" class="mb-6">
          <div v-if="errors.length" class="red">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="(error, index) in errors" :key="index" class="red" v-text="error" />
              </ul>
          </div>
          <form class="text-center mx-auto" @submit.prevent="findAccount()">
            <input type="text" placeholder="Account Number *" class="w-full" v-model="accountNo" />
            <input type="text" placeholder="Last Name *" class="w-full" v-model="lastName" />
            <input type="text" placeholder="Zipcode *" class="w-full" v-model="zipCode" />
            <input type="submit" :disabled="isFindingAccount" class="button w-300 mt-4" value="Submit" />
          </form>
        </div>
  
        <p>
          <strong>Having Trouble?</strong><br />
          If you’re having difficulties with your payment or need assistance,
          contact your representative.
        </p>
  
        <p>
          <strong>Your Local Franchise</strong><br />
          <span v-text="franchiseName" /><br />
          <span v-html="franchiseAddress" /><br />
          <span v-text="formatPhoneNumber(franchisePhone) ?? franchisePhone" />
        </p>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
    import { useStore } from 'vuex';
    import type { Store } from 'vuex/types/index.js';
    import type State from '~/domains/store/State';
    import { formatPhoneNumber } from '~/utils/phone';

    const props = defineProps({
        franchiseName: String,
        franchiseAddress: String,
        franchisePhone: String,
        redirectPath: String
    });

    const { $customers, $sg, $userContext } = useNuxtApp();
    const store: Store<State> = useStore();

    const verifyForm = ref(false);
    const isFindingAccount = ref(false);
    const accountNo = ref('');
    const lastName = ref('');
    const zipCode = ref('');
    const errors = ref([]);

    const findAccount = async () => {
        if (isFindingAccount.value) {
            return;
        }

        try {
            isFindingAccount.value = true;
            errors.value = [];

            const customer = await $customers.getCustomerByInfo(accountNo.value.trim(), lastName.value.trim(), zipCode.value.trim());

            if (customer?.error || !customer?.cust_No) {
            throw new Error("We were unable to find an account with that information. Please try again.");
            }

            if (customer.sqldbid !== store.state.persistedState.sqldbid || customer.cust_No !== store.state.persistedState.cust_No) {
                const franchiseInfo = await $sg.getApiData(`Companies/SG/Franchise/SQLDBID/${customer.sqldbid}`);
                await $userContext.refresh({
                    clearState: true,
                    stateUpdate: {
                    branchCode: franchiseInfo.branchNo,
                    custNo: customer.cust_No,
                    },
                    refresh: new Set(["ALL"]),
                });
            }

        } catch (ex) {
            console.error(ex);
            errors.value.push(ex.message);
        } finally {
            isFindingAccount.value = false;
        }
    };
  </script>
  
  <style scoped>
  </style>
  